// 三个步骤
import React from 'react';
import { ButtonProps } from '@/components/Button';
import LeadButton from '@/components/LeadButton';
import cls from 'classnames';
import Title, { TitleProps } from '@/components/Title';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { getGa4PageName } from '@/utils/utils';

interface Props {
  blockTitle: string;
  steps1name: string;
  steps2name: string;
  steps3name: string;
  className?: string;
  subject: 'math' | 'english' | 'chinese';
  // 页面需要引用对应页面的多语言
  useTranslationName: string;
}

const CTA: React.FC<Props> = ({
  className,
  subject,
  blockTitle,
  steps1name,
  steps2name,
  steps3name,
  useTranslationName,
}) => {
  const { t } = useTranslation([useTranslationName]);
  const router = useRouter();
  const currentPath = router.pathname;
  const TitleThemeClass: Record<string, TitleProps['theme']> = {
    math: 'math',
    english: 'english',
    chinese: 'red',
  };

  const ButtonThemeClass: Record<string, ButtonProps['theme']> = {
    math: 'math',
    english: 'english',
    chinese: 'red',
  };
  // TODO chinese切图
  const bg = {
    math: "bg-[url('/images/CAT/line-math-m.png')] lg:bg-[url('/images/CAT/line-math-pc-s.png')] xl:bg-[url('/images/CAT/line-math-pc-l.png')] ",
    english:
      "bg-[url('/images/CAT/line-english-m.png')] lg:bg-[url('/images/CAT/line-english-pc-s.png')] xl:bg-[url('/images/CAT/line-english-pc-l.png')] ",
    chinese:
      "bg-[url('/images/CAT/line-chinese-m.png')] lg:bg-[url('/images/CAT/line-chinese-pc-s.png')] xl:bg-[url('/images/CAT/line-chinese-pc-l.png')] ",
  };

  return (
    <div className={cls('', className)}>
      <div className="container">
        <Title className="mb-6" innerHTML theme={TitleThemeClass[subject]}>
          {t(blockTitle)}
        </Title>
      </div>
      <div
        className={cls(
          'relative mt-6 h-[64px] overflow-hidden bg-cover bg-center bg-no-repeat lg:mt-12 lg:h-25 xl:mt-15 xl:h-[140px]',
          bg[subject],
        )}
      />
      <div className="mx-auto  flex w-[360px] flex-row  justify-center  lg:mt-2 lg:w-[944px] lg:space-x-28 xl:w-[1160px] xl:space-x-[220px]">
        <span className="  inline-block   px-2 text-center  lg:flex-1">
          <LeadButton
            subject={subject}
            theme={ButtonThemeClass[subject]}
            className=" m-auto w-[104px] py-2 text-base font-semibold lg:w-auto lg:px-10 lg:py-3 lg:text-xl xl:px-12"
            traceName="O_ThreeSteps_RegisterAccountClick"
            traceGa4Name={`new_entry_${getGa4PageName(currentPath)}_ThreeSteps_RegisterAccountClick`}
            traceData={{
              page_name: currentPath,
            }}
            htmlLabel="h3"
          >
            {t(steps1name)}
          </LeadButton>
        </span>
        <h3 className="  inline-block flex-1  text-wrap  px-3 text-center text-sm lg:flex-1 lg:px-0  lg:text-xl">
          {t(steps2name)}
        </h3>
        <h3 className="  inline-block flex-1  text-wrap  px-3 text-center  text-sm lg:flex-1  lg:px-0  lg:text-xl">
          {t(steps3name)}
        </h3>
      </div>
    </div>
  );
};

export default CTA;
